import { useEffect, useState } from "react";
import { Bot } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

// « Robot trieur » per REF: inside the business plan, or its own small subscription (group seat / custom plan).
export const RobotCard = () => {
  const { t, fmtDate } = useI18n();
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/admin/revenue/carts/robots").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  if (!list?.length) return null;
  return (
    <section className="card-carbon min-w-0 space-y-3 rounded-2xl p-4" data-testid="admin-robot-card">
      <h2 className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-[var(--gold-bright)]"><Bot className="h-4 w-4 shrink-0" /> {t("robot.adminTitle")}</h2>
      <ul className="min-w-0 space-y-1 text-xs">
        {list.map((r) => (
          <li key={`${r.key_id}-${r.ref}-${r.mode}`} className="flex min-w-0 flex-wrap items-center gap-x-2 break-words text-neutral-300" data-testid={`admin-robot-${r.ref}`}>
            <span className="font-semibold text-white" dir="ltr">{r.ref}</span>
            <span className={r.active ? "text-emerald-300" : "text-neutral-500"}>{t(r.active ? "robot.on" : "robot.off")}</span>
            <span>· {t(r.mode === "solo" ? "robot.modeSolo" : "robot.modePlan")}</span>
            {r.until && <span>· {fmtDate(r.until)}</span>}
          </li>
        ))}
      </ul>
    </section>
  );
};
